import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { TypeVoie } from '../models/TypeVoie';
import { Step5 } from '../../../../shared/models/component-messages/diveAT/step5';

@Component({
  selector: 'app-type-voie',
  templateUrl: './type-voie.component.html'
})
export class TypeVoieComponent implements OnInit {

  @Input() uid = '';
  public current_uid = 'TypeVoie';
  @Input() parentForm: FormGroup;
  @Input() disabled: boolean;
  @Input() voie: TypeVoie;
  @Input() rule = '';
  @Input() errorMessage = '';

  public step5 = new Step5();

  constructor() {
  }

  public ngOnInit() {
  }

  public getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }
}
